import { render, staticRenderFns } from "./gates-of-love.vue?vue&type=template&id=641f0d0b&"
import script from "./gates-of-love.vue?vue&type=script&lang=js&"
export * from "./gates-of-love.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports